module.exports = __webpack_public_path__ + "img/VUT.8f014c68.gif";